import Layout from 'components/Layout';
import { Route, Routes } from 'react-router-dom';
import GetStarted from './pages/GetStartedPage';
import GeneratedPage from './pages/GeneratedPage';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
const ImageToImage = () => {
  return (
    <Layout>
      <GoogleReCaptchaProvider
        reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY!}
      >
        <Routes>
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/result" element={<GeneratedPage />} />
        </Routes>
      </GoogleReCaptchaProvider>
    </Layout>
  );
}

export default ImageToImage;
